import { LocationListItem, LocationInfo, ChargingSession, ChargingSessionState } from './../../shared/types/location'
import {
    ADD_CHARGER,
    DELETE_CHARGER,
    EDIT_CHARGER,
    FETCH_LOCATION_FOR_DETAIL,
    ADD_LOCATION,
    EDIT_LOCATION,
    DELETE_LOCATION,
    UPLOAD_LOCATION_PHOTOS,
    DELETE_LOCATION_PHOTO,
    UPLOAD_CHARGER_PHOTOS,
    DELETE_CHARGER_PHOTO,
    SEARCH_LOCATIONS,
    UPDATE_CONNECTOR_AVAILABILITY,
    STOP_CHARGING,
    START_CHARGING,
    UPDATE_LOCATION_WHITELIST,
    RESET_START_CHARGING_STATE,
    RESET_STOP_CHARGING_STATE,
    CHANGE_CHARGER_CONFIGURATION,
    FETCH_CHARGER_CONFIGURATION,
    RESET_CHARGER_CONFIGURATION_STATE,
    UPDATE_LOCATION_FLEXICHARGING,
} from './../const/index'
import { Image } from '../../shared/types/common'
import { ChargerConnectorState } from '../../shared/types/charger'

export const locationChargersReducer =
    () =>
    (state = { chargers: new Array<any>() }, action: any) => {
        switch (action.type) {
            case `${FETCH_LOCATION_FOR_DETAIL}_SUCCESS`: {
                return {
                    locationId: action.payload.result.id,
                    chargers: action.payload.result.chargers.map((x: any) => {
                        return {
                            ...x,
                        }
                    }),
                }
            }
            case `${ADD_CHARGER}_SUCCESS`: {
                return {
                    ...state,
                    chargers: [...state.chargers, action.payload.result],
                }
            }
            case `${DELETE_CHARGER}_SUCCESS`: {
                return {
                    ...state,
                    chargers: state.chargers.filter((x) => x.id !== action.payload.chargerId),
                }
            }
            case `${EDIT_CHARGER}_SUCCESS`: {
                return {
                    ...state,
                    chargers: state.chargers.map((x) =>
                        x.id === action.payload.result.id ? action.payload.result : x
                    ),
                }
            }
            case `${UPLOAD_CHARGER_PHOTOS}_SUCCESS`: {
                return {
                    ...state,
                    chargers: state.chargers.map((x) => {
                        if (x.id === action.payload.chargerId) {
                            x.images = x.images.concat(action.payload.result)
                        }
                        return x
                    }),
                }
            }
            case `${DELETE_CHARGER_PHOTO}_SUCCESS`: {
                return {
                    ...state,
                    chargers: state.chargers.map((x) => {
                        if (x.id === action.payload.chargerId) {
                            x.images = x.images.filter((image: Image) => image.id !== action.payload.photoId)
                        }
                        return x
                    }),
                }
            }
            default: {
                return state
            }
        }
    }

export const locationsListUpdateReducer = (state: any, action: any) => {
    switch (action.type) {
        case `${EDIT_LOCATION}_SUCCESS`: {
            return {
                ...state,
                data: state.data.map((x: LocationListItem) =>
                    x.id === action.payload.result.id ? { ...action.payload.result } : x
                ),
            }
        }
        case `${DELETE_LOCATION}_SUCCESS`: {
            return {
                ...state,
                data: state.data.filter((x: LocationListItem) => x.id !== action.payload.locationId),
            }
        }
        case `${UPLOAD_LOCATION_PHOTOS}_SUCCESS`: {
            return {
                ...state,
                data: state.data.map((x: LocationListItem) =>
                    x.id === action.payload.locationId ? { ...x, images: x.images.concat(action.payload.result) } : x
                ),
            }
        }
        case `${DELETE_LOCATION_PHOTO}_SUCCESS`: {
            return {
                ...state,
                data: state.data.map((x: LocationListItem) =>
                    x.id === action.payload.locationId
                        ? { ...x, images: x.images.filter((y) => y.id !== action.payload.photoId) }
                        : x
                ),
            }
        }
        case `${START_CHARGING}_SUCCESS`: {
            const updateLocation = (locations: LocationListItem[]) =>
                locations.map((location: LocationListItem) => {
                    if (location.id === action.payload.result.locationId) {
                        return {
                            ...location,
                            availableConnectors: Math.max(0, (location.availableConnectors || 0) - 1),
                            chargingSessionsInProgressCount: (location.chargingSessionsInProgressCount || 0) + 1,
                        }
                    }
                    return location
                })

            return {
                ...state,
                data: updateLocation(state.data),
                value: {
                    ...state.value,
                    items: updateLocation(state.value.items),
                },
            }
        }
        default:
            return state
    }
}

const updateMapLocation = (location: LocationInfo): LocationInfo => ({
    id: location.id,
    latitude: location.latitude,
    longitude: location.longitude,
    chargerCount: location.chargerCount,
    chargersInUseCount: location.chargersInUseCount,
    availableConnectors: location.availableConnectors,
    workingConnectors: location.workingConnectors,
    connectedChargers: location.connectedChargers,
    connectorCount: location.connectorCount,
})

export const locationsMapUpdateReducer = (state: any, action: any) => {
    switch (action.type) {
        case `${ADD_LOCATION}_SUCCESS`: {
            return {
                ...state,
                value: state.value.concat([updateMapLocation(action.payload.result)]),
            }
        }
        case `${EDIT_LOCATION}_SUCCESS`: {
            const updatedLocation = action.payload.result
            let currentLocation = state.value.filter((location: LocationInfo) => location.id === updatedLocation.id)[0]
            if (
                currentLocation.latitude !== updatedLocation.latitude ||
                currentLocation.longitude !== updatedLocation.longitude ||
                currentLocation.chargerCount !== updatedLocation.chargerCount ||
                currentLocation.chargersInUseCount !== updatedLocation.chargersInUseCount ||
                currentLocation.availableConnectors !== updatedLocation.availableConnectors ||
                currentLocation.workingConnectors !== updatedLocation.workingConnectors ||
                currentLocation.connectedChargers !== updatedLocation.connectedChargers ||
                currentLocation.connectorCount !== updatedLocation.connectorCount
            ) {
                return {
                    ...state,
                    value: state.value.map((x: LocationInfo) =>
                        x.id === updatedLocation.id ? updateMapLocation(action.payload.result) : x
                    ),
                }
            }
            return state
        }
        case `${DELETE_LOCATION}_SUCCESS`: {
            return {
                ...state,
                value: state.value.filter((x: LocationListItem) => x.id !== action.payload.locationId),
            }
        }
        // case `${FETCH_LIST_LOCATIONS}_SUCCESS`: {
        //     const updatedItems = action.payload.result.items || []

        //     if (updatedItems.length === 0) {
        //         return state
        //     }

        //     const updatedItemsMap = new Map(updatedItems.map((item: LocationListItem) => [item.id, item]))

        //     return {
        //         ...state,
        //         value: state.value.map((x: LocationListItem) => {
        //             const updatedItem = updatedItemsMap.get(x.id)
        //             return updatedItem ? updatedItem : x
        //         }),
        //     }
        // }
        default:
            return state
    }
}

export const locationDetailUpdateReducer = (state: any, action: any) => {
    switch (action.type) {
        case `${UPLOAD_LOCATION_PHOTOS}_SUCCESS`: {
            return {
                ...state,
                value:
                    state.value.id === action.payload.locationId
                        ? { ...state.value, images: state.value.images.concat(action.payload.result) }
                        : state.value,
            }
        }
        case `${DELETE_LOCATION_PHOTO}_SUCCESS`: {
            return {
                ...state,
                value:
                    state.value.id === action.payload.locationId
                        ? {
                              ...state.value,
                              images: state.value.images.filter((y: any) => y.id !== action.payload.photoId),
                          }
                        : state.value,
            }
        }
        case `${UPDATE_CONNECTOR_AVAILABILITY}`: {
            if (!state.value || !state.value.chargers) {
                return state
            }
            return {
                ...state,
                value: {
                    ...state.value,
                    chargers: state.value.chargers.map((charger: any) => {
                        if (charger.id === action.payload.value.chargerId) {
                            return {
                                ...charger,
                                connectors: charger.connectors.map((connector: any) => {
                                    if (connector.id === action.payload.value.connectorId) {
                                        return {
                                            ...connector,
                                            availability: action.payload.value.availType,
                                        }
                                    }
                                    return connector
                                }),
                            }
                        }
                        return charger
                    }),
                },
            }
        }
        case `${EDIT_LOCATION}_SUCCESS`: {
            if (!state.value) {
                return state
            }
            return {
                ...state,
                value: state.value.id === action.payload.result.id ? state.value : null,
            }
        }
        case `${STOP_CHARGING}_SUCCESS`: {
            if (!state.value) {
                return state
            }
            console.log(action.payload.result)

            const sessionId = action.payload.result?.id
            return {
                ...state,
                value: {
                    ...state.value,
                    currentSessions: (state.value.currentSessions || []).filter(
                        (session: ChargingSession) => session.id !== sessionId
                    ),
                },
            }
        }
        case `${START_CHARGING}_SUCCESS`: {
            if (!state.value) {
                return state
            }

            const newSession = action.payload.result
            const chargerId = newSession.charger.id
            const connectorId = newSession.chargingConnector.id

            return {
                ...state,
                value: {
                    ...state.value,
                    // Update currentSessions
                    currentSessions: [
                        ...(state.value.currentSessions?.filter(
                            (session: ChargingSession) =>
                                !(
                                    session.chargingConnectorId === null &&
                                    session.idTag === newSession.idTag &&
                                    session.state === ChargingSessionState.InProgress
                                )
                        ) || []),
                        newSession,
                    ],
                    // Update chargers and their connectors
                    chargers: (state.value.chargers || []).map((charger: any) => {
                        if (charger.id === chargerId) {
                            return {
                                ...charger,
                                connectors: (charger.connectors || []).map((connector: any) => {
                                    if (connector.id === connectorId) {
                                        return {
                                            ...connector,
                                            inPreparingState: false,
                                            state: ChargerConnectorState.Busy,
                                        }
                                    }
                                    return connector
                                }),
                            }
                        }
                        return charger
                    }),
                },
            }
        }
        case `${UPDATE_LOCATION_WHITELIST}_SUCCESS`: {
            if (!state.value) {
                return state
            }
            return {
                ...state,
                value: {
                    ...state.value,
                    whitelist: action.payload.result,
                },
            }
        }
        case `${UPDATE_LOCATION_FLEXICHARGING}_SUCCESS`: {
            if (!state.value) {
                return state
            }

            // action.payload.result je pravdepodobne uložená lokalita vrátená z BE
            const updatedLocation = action.payload.result

            return {
                ...state,
                // Ak uložená lokalita má rovnaké ID ako tá v state, nahradíme ju novými dátami
                value: state.value.id === updatedLocation.id ? updatedLocation : state.value,
            }
        }
        case RESET_STOP_CHARGING_STATE:
        case RESET_START_CHARGING_STATE: {
            return {
                ...state,
                executed: false,
                error: null,
            }
        }
        default:
            return state
    }
}

export const chargerConfigurationItemsReducer = (state: any = { value: [] }, action: any) => {
    switch (action.type) {
        case `${FETCH_CHARGER_CONFIGURATION}_SUCCESS`: {
            return {
                ...state,
                value: action.payload.result,
            }
        }
        default:
            return state
    }
}

export const chargerConfigurationUpdateReducer = (state: any = { executed: false }, action: any) => {
    switch (action.type) {
        case `${CHANGE_CHARGER_CONFIGURATION}_SUCCESS`: {
            return {
                ...state,
                executed: true,
                value: action.payload.result,
            }
        }
        case RESET_CHARGER_CONFIGURATION_STATE: {
            return {
                executed: false,
                error: null,
                value: [],
            }
        }
        default:
            return state
    }
}

export const locationSelectedIdUpdateReducer = (state: any, action: any) => {
    switch (action.type) {
        case SEARCH_LOCATIONS: {
            return {
                ...state,
                value: null,
            }
        }
        case `${DELETE_LOCATION}_SUCCESS`: {
            if (state.value === action.payload.locationId) {
                return {
                    ...state,
                    value: null,
                }
            } else {
                return state
            }
        }
        default:
            return state
    }
}
